import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'i18nLabelViaje'
})
export class I18nLabelViajePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: { nombre: string; nombreIngles?: string }): string {
    if (!value) return '';

    const lang = this.translate.currentLang?.toLowerCase() || 'es';

    // Si el idioma es inglés pero no hay nombre en inglés válido, se muestra el nombre en español
    if (lang === 'en') {
      return value.nombreIngles?.trim() || value.nombre || '';
    }

    // Para cualquier otro idioma (incluyendo español o idioma indefinido), mostrar en español
    return value.nombre || '';
  }
}